<ng-container *ngIf="allHoldings$ | async as allHoldings">
  <div class="flex-container">
    <div class="action-container">
      <div class="add-new-user">
        <button mat-flat-button (click)="addNewUser(allHoldings)" class="action-btn add-new-user-button">
          <mat-icon class="notranslate">add</mat-icon>
          Add a New User
        </button>
      </div>

    </div>
    <div class="table-container">
      <!-- Data table -->
      <table mat-table [dataSource]="dataSource" [trackBy]="trackByFunction"
             class="user-and-permission-table cov-basic-table" matSort matSortDisableClear
             (matSortChange)="sortData($event)">

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="name" class="name-col-header">Name</th>
          <td mat-cell *matCellDef="let element" class="lo_sensitive name-cell" matTooltip="{{ element.name }}"
              matTooltipClass="terra-tooltip-compact">
            {{ element.name | truncate: 30 }}
          </td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="email" class="email-col-header">Email</th>
          <td mat-cell *matCellDef="let element" class="lo_sensitive email-cell" matTooltip="{{ element.email }}"
              matTooltipClass="terra-tooltip-compact">
            {{ element.email | truncate: 20:true }}
          </td>
        </ng-container>

        <!-- Permission Level -->
        <ng-container matColumnDef="permissionLevel">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="permissionLevel" class="permission-level">
            Role
          </th>
          <td mat-cell *matCellDef="let element" class="lo_sensitive">
            {{ element.permissionLevel | enumString: PermissionLevel }}
          </td>
        </ng-container>

        <!-- Sections -->
        <ng-container matColumnDef="sections">
          <th mat-header-cell *matHeaderCellDef class="sections">Sections</th>
          <td mat-cell *matCellDef="let element" class="lo_sensitive" matTooltip="{{element.allowedSections | sections:'pipe'}}"
              matTooltipClass="terra-tooltip-compact">
            {{ element.allowedSections | sections:'table' }}
          </td>
        </ng-container>

        <!-- Holding -->
        <ng-container matColumnDef="holding">
          <th mat-header-cell *matHeaderCellDef class="holding">Holding</th>
          <td mat-cell *matCellDef="let element" class="lo_sensitive">
            {{ element.holdings.length }}/{{ allHoldings?.length }}
          </td>
        </ng-container>

        <!-- Financial Permissions -->
        <ng-container matColumnDef="financialPermissions">
          <th mat-header-cell *matHeaderCellDef class="financialPermissions">Financial Permissions</th>
          <td mat-cell *matCellDef="let element" class="lo_sensitive">
            {{ element.financialPermission | enumString: FinancialPermissionLevel }}
          </td>
        </ng-container>

        <!-- Contacts Visibility -->
        <ng-container matColumnDef="contactsVisibility">
          <th mat-header-cell *matHeaderCellDef class="contactsVisibility">Contacts Visibility</th>
          <td mat-cell *matCellDef="let element" class="lo_sensitive">
            {{ element.contactsVisibility | enumString: ContactsVisibilityPermission }}
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="actions-col-header"></th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div class="actions-container">
              <button mat-icon-button class="edit-button action-btn"
                      (click)="onEditRow(element, allHoldings); $event.stopPropagation(); (false)" disableRipple
                      matTooltip="Edit" matTooltipClass="terra-tooltip-compact" [disabled]="(emailOfCurrentUser$ | async) === element.email">
                <mat-icon class="edit-icon notranslate">edit</mat-icon>
              </button>
              <button mat-icon-button class="delete-button" [disabled]="(emailOfCurrentUser$ | async) === element.email"
                      (click)="onDeleteRow(element); $event.stopPropagation(); (false)" disableRipple
                      matTooltip="Delete" matTooltipClass="terra-tooltip-compact">
                <mat-icon class="delete-icon notranslate">delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <tr mat-row *matRowDef="let row; columns: displayedColumns" (mouseover)="row.hover = true"
            (mouseout)="row.hover = false" class="value-row" [class.hide]="isLoading$ | async"></tr>
      </table>

      <terra-loader *ngIf="isLoading$ | async" class="user-and-permission-table-loader"></terra-loader>

    </div>
  </div>
</ng-container>
